import { styled } from '@mui/material';
import { Chip as ChipMui } from '@mui/material';

export const TreeItemWrapper = styled('div')(() => ({
  display: 'flex',
  paddingTop: '16px',
  gap: 6,
  alignItems: 'center',
  '& > *:first-child': {
    flex: '1 1 100%',
    paddingLeft: '34px',
  },
  '& > *:last-child': {
    paddingRight: '7px',
  },
}));

export const Chip = styled(ChipMui)(() => ({
  border: 0,
}));
